import clsx from 'clsx'
import styles from './ac-step-indicator.module.scss'

type IAcStepIndicator = {
  steps: string[]
  currentStep: number
  completedSteps: number[]
}

export const AcStepIndicator = ({
  steps,
  currentStep,
  completedSteps,
}: IAcStepIndicator) => {
  return (
    <div className={styles['ac-step-indicator']}>
      {steps.map((label, index) => {
        const stepNumber = index + 1
        const isActive = stepNumber === currentStep
        const isCompleted = completedSteps.includes(stepNumber)

        return (
          <div
            key={stepNumber}
            className={clsx(
              styles['ac-step-indicator__step'],
              isActive && styles['ac-step-indicator__step--active'],
              isCompleted && styles['ac-step-indicator__step--completed']
            )}>
            <div className={styles['ac-step-indicator__circle']}>
              {isCompleted ? (
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 7L5.5 10.5L12 3.5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                stepNumber
              )}
            </div>
            <span className={styles['ac-step-indicator__label']}>{label}</span>
          </div>
        )
      })}
    </div>
  )
}
